/**
 * VERI – Fit-Text (Nachbau Squarespace „scaled text“ / sqsrte-scaled-text)
 *
 * Jede Zeile wird einzeln so skaliert, dass sie exakt die Breite des Containers füllt.
 * Gemessen live: Startseite Hero „GIBT DEINER HAUT / DAS SIGNAL / SICH SELBST / ZU REGENERIEREN“
 * (Jost 300, uppercase) 80.6 / 120.8 / 121.2 / 80.3 px bei Blockbreite 657 px (@1440).
 *
 * Markup:
 *   <div class="veri-fit-text" data-veri-fit-text [data-fit-max="200"] [data-fit-min="10"]
 *        style="--veri-fit-fallback: 80px">
 *     <span class="veri-fit-text__line">GIBT DEINER HAUT</span>
 *     <span class="veri-fit-text__line">DAS SIGNAL</span>
 *   </div>
 *
 * - Container-Breite = Breite von [data-veri-fit-text] (Grid-Item/Spalte bestimmt sie).
 * - Optional data-fit-line-height (Default 1) für die Zeilenhöhe.
 * - Ohne JS greift --veri-fit-fallback (CSS in veri-base.css).
 * - Reagiert auf Resize (ResizeObserver), Font-Laden (document.fonts) und Theme-Editor-Events.
 * - API: window.VeriFitText.refresh([root])
 */
(function () {
  'use strict';

  var REF_SIZE = 100; // Referenz-Schriftgröße für die Messung (px)

  function fitElement(el) {
    var width = el.clientWidth;
    if (!width) return;
    var max = parseFloat(el.getAttribute('data-fit-max')) || Infinity;
    var min = parseFloat(el.getAttribute('data-fit-min')) || 0;
    var lh = el.getAttribute('data-fit-line-height');
    var lines = el.querySelectorAll('.veri-fit-text__line');

    lines.forEach(function (line) {
      line.style.display = 'inline-block';
      line.style.fontSize = REF_SIZE + 'px';
    });
    lines.forEach(function (line) {
      var natural = line.getBoundingClientRect().width;
      if (!natural) return;
      var size = (width / natural) * REF_SIZE;
      size = Math.max(min, Math.min(max, size));
      line.style.fontSize = size.toFixed(2) + 'px';
      line.style.display = 'block';
      if (lh) line.style.lineHeight = lh;
    });
    el.classList.add('is-fitted');
  }

  function refresh(root) {
    (root || document).querySelectorAll('[data-veri-fit-text]').forEach(fitElement);
  }

  var ro = 'ResizeObserver' in window
    ? new ResizeObserver(function (entries) {
        entries.forEach(function (entry) { fitElement(entry.target); });
      })
    : null;

  function observe(root) {
    (root || document).querySelectorAll('[data-veri-fit-text]').forEach(function (el) {
      if (ro && !el.__veriFitObserved) {
        ro.observe(el);
        el.__veriFitObserved = true;
      }
      fitElement(el);
    });
  }

  function init() {
    observe();
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { refresh(); });
    }
    if (!ro) window.addEventListener('resize', function () { refresh(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme-Editor: Sections werden neu geladen
  document.addEventListener('shopify:section:load', function (e) { observe(e.target); });

  window.VeriFitText = { refresh: refresh, fit: fitElement };
})();
